import { ReactNode, useRef } from 'react';
import { useRouter } from 'next/router';
import { WebViewContext } from './webview.context';

type TWebViewProviderProps = {
    children: ReactNode;
};

export function WebViewProvider({
    children,
}: TWebViewProviderProps): JSX.Element {
    const router = useRouter();
    const isWebviewReference = useRef<boolean>(
        router.asPath.includes('webview=true')
    );

    return (
        <WebViewContext.Provider value={isWebviewReference.current}>
            {children}
        </WebViewContext.Provider>
    );
}
